import Script from "next/script";

export default function FBScript() {
  return (
    <Script>
      {`window.fbAsyncInit = function() {
        FB.init({
          appId      : '821357816461898',
          cookie     : true,
          xfbml      : true,
          version    : 'v19.0'
        });
        FB.AppEvents.logPageView();   
      };

      (function(d, s, id){
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {return;}
        js = d.createElement(s); js.id = id;
        js.src = "https://connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', 'facebook-jssdk'));
      `}
    </Script>
  );
}


